import React from "react";
import Card from "react-md/lib/Cards/Card";
import { Route } from "react-router-dom";
import Toolbar from "../../admin/components/Toolbar";
import EditCustomer from "./EditCustomer";
import SearchCustomer from "./SearchCustomer";
import Message from "./Message";

const SearchCustomerWithStyle = () => (
  <SearchCustomer className="md-cell md-cell--3" />
);
const EditCustomerWithStyle = () => (
  <EditCustomer className="md-cell md-cell--9" />
);

const CustomerPage = () => (
  <div>
    <Toolbar />
    <div className="md-grid" style={{ marginTop: 64 }}>
      <Card
        className="md-cell md-cell--12"
        style={{ minHeight: "calc(100vh - 100px)" }}
      >
        <div className="md-grid">
          <Route path="/customer" component={SearchCustomerWithStyle} />
          <Route
            path="/customer/:customerId"
            component={EditCustomerWithStyle}
          />
        </div>
      </Card>
    </div>
    <Message />
  </div>
);

export default CustomerPage;



// WEBPACK FOOTER //
// ./src/customer/components/CustomerPage.jsx